var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3771 3.5714L18.8222 7.44794C18.9674 7.61125 18.9674 7.87771 18.8222 8.04102L10.4806 17.4272L6.93611 17.8699C6.4625 17.9301 6.06146 17.4788 6.11493 16.9459L6.50833 12.9576L14.85 3.5714C14.9951 3.40809 15.2319 3.40809 15.3771 3.5714ZM21.5646 2.58722L19.7007 0.489939C19.1201 -0.163313 18.1767 -0.163313 17.5924 0.489939L16.2403 2.01133C16.0951 2.17464 16.0951 2.4411 16.2403 2.60441L19.6854 6.48095C19.8306 6.64427 20.0674 6.64427 20.2125 6.48095L21.5646 4.95956C22.1451 4.30201 22.1451 3.24048 21.5646 2.58722ZM14.6667 14.8744V19.2495H2.44444V5.49678H11.2215C11.3437 5.49678 11.4583 5.44091 11.5462 5.34636L13.074 3.62727C13.3642 3.30064 13.158 2.74624 12.7493 2.74624H1.83333C0.821181 2.74624 0 3.67025 0 4.80914V19.9371C0 21.076 0.821181 22 1.83333 22H15.2778C16.2899 22 17.1111 21.076 17.1111 19.9371V13.1553C17.1111 12.6954 16.6184 12.4677 16.3281 12.79L14.8003 14.5091C14.7163 14.6079 14.6667 14.7369 14.6667 14.8744Z",
    fill: "#6638A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.32e47288dcb653e28ba8c92b95e579ec.svg";
export { ForwardRef as ReactComponent };